import { baseApi } from "configs/store-query";
import {
  AuthenticationUserIdentifierResendVerificationApiRequest,
  AuthenticationUserIdentifierResendVerificationApiResponse,
  AuthenticationUserIdentifierVerifyApiRequest,
  AuthenticationUserIdentifierVerifyApiResponse,
} from "apis/authentication/types/authentication-user-identifier-api";

const BASE_PATH = "/authentication/user-identifier";

export const authenticationUserIdentifierController = baseApi.injectEndpoints({
  endpoints: (build) => ({
    resendUserIdentifierVerificationAuthentication: build.mutation<
      AuthenticationUserIdentifierResendVerificationApiResponse,
      AuthenticationUserIdentifierResendVerificationApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/resend-verification`,
        method: "POST",
        ...config,
      }),
    }),
    verifyUserIdentifierVerificationAuthentication: build.mutation<
      AuthenticationUserIdentifierVerifyApiResponse,
      AuthenticationUserIdentifierVerifyApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/verify`,
        method: "POST",
        ...config,
      }),
    }),
  }),
});
